<template>
  <v-container fill-height fluid style="height: 100%; padding: 0;">
    <v-layout fill-height row wrap style="height: 100%">
      <AdminSideBarMenu />
      <v-flex class="dashboard-view">
        <v-breadcrumbs>
          <v-breadcrumbs-item :disabled="true">Admin</v-breadcrumbs-item>
          <v-breadcrumbs-item :disabled="true">Resources</v-breadcrumbs-item>
          <v-breadcrumbs-item :disabled="true">New Resource</v-breadcrumbs-item>
        </v-breadcrumbs>
        <v-card class="bordered-card" style="height: 100%;">
          <v-toolbar class="grey lighten-4 elevation-0">
            <v-toolbar-title class="grey--text text-underline text--darken-4">
              Add New Resource
            </v-toolbar-title>
          </v-toolbar>
          <v-card-text style="">
              <v-layout>
                  <v-flex xs12 md9>
                    <input type="text" class="form-control" placeholder="Enter title here" style="height: 40px;" v-model="resource.title">
                    <vue-editor v-model="resource.content" :editorToolbar="customToolbar"></vue-editor>
                    <v-flex xs6>
                      <span style="margin-top: 18px;font-size: 18px;display:block;">Media Type</span>
                      <v-radio-group v-model="mediaType" row>
                        <v-radio label="Image" value="image" ></v-radio>
                        <v-radio label="Video" value="video"></v-radio>
                      </v-radio-group>
                    </v-flex>
                    <v-card v-if="mediaType === 'image'" class="bordered-card mt-3">
                        <v-toolbar dense class="grey lighten-4 elevation-0">
                            <v-toolbar-title dense class="grey--text text-underline text--darken-4">
                              Featured Image (<strong>Recommendation: No larger than 640x480</strong>)
                            </v-toolbar-title>
                        </v-toolbar>
                        <v-card-text>
                            <v-card v-if="resourcePhotoFile!==''" class="mt-0 pt-0">
                                <div style="width:100%">
                                    <v-btn icon class="" id='close' @click.prevent="cancelResourcePhoto()">
                                        <v-icon style="font-size: 15px;" >close</v-icon>
                                    </v-btn>
                                    <img :src="resourcePhotoFileURL" id="resourceActivity" style="max-width:100%;">
                                </div>
                            </v-card>
                            <v-btn v-else @click="resourcePhotoUploaded = true">
                                <v-icon medium>insert_photo</v-icon>
                                Add Media
                            </v-btn>

                            <file-upload :trigger="resourcePhotoUploaded" @cancel="resourcePhotoUploaded=false;resourcePhotoFile=''" :formats="['jpeg','png','jpg']" v-model="resourcePhotoFile" @confirm="showResourcePhoto()"></file-upload>
                        </v-card-text>
                    </v-card>
                    <v-card v-if="mediaType === 'video'" class="bordered-card mt-3">
                        <v-toolbar dense class="grey lighten-4 elevation-0">
                            <v-toolbar-title dense class="grey--text text-underline text--darken-4">
                              Featured Video
                            </v-toolbar-title>
                        </v-toolbar>
                        <v-card-text>
                            <input type="text" class="form-control" placeholder="Video link e.g youtube or vimeo" style="height: 40px;" v-model="videoLink">
                        </v-card-text>
                    </v-card>
                    <v-layout>
                        <v-btn style="margin:10px 0px;" class="primary" @click.prevent="addResource()" :loading="this.$store.getters.getLoading && resourceProcess">
                            Save
                            <span slot="loader" class="custom-loader">
                                <v-icon dark>cached</v-icon>
                            </span>
                        </v-btn>
                        <v-btn style="margin:10px 10px;" class="secondary" @click.prevent="goBack" :disabled="this.$store.getters.getLoading && resourceProcess">
                          Cancel
                        </v-btn>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 md3>
                    <v-card class="bordered-card ml-4">
                        <v-toolbar dense class="grey lighten-4 elevation-0">
                            <v-toolbar-title dense class="grey--text text-underline text--darken-4">
                                Content Type
                            </v-toolbar-title>
                        </v-toolbar>
                        <v-card-text>
                            <v-radio-group v-model="resource.contenttype">
                                <v-radio
                                    v-for="n in contentTypes"
                                    :key="n"
                                    :label="`${n}`"
                                    :value="n"
                                ></v-radio>
                            </v-radio-group>
                        </v-card-text>
                    </v-card>
                    <v-card class="bordered-card ml-4 mt-4">
                        <v-toolbar dense class="grey lighten-4 elevation-0">
                            <v-toolbar-title dense class="grey--text text-underline text--darken-4">
                                Category
                            </v-toolbar-title>
                        </v-toolbar>
                        <v-card-text>
                            <v-radio-group v-model="resource.category">
                                <v-radio
                                    v-for="n in categories"
                                    :key="n"
                                    :label="`${n}`"
                                    :value="n"
                                ></v-radio>
                            </v-radio-group>
                        </v-card-text>
                    </v-card>

                    <v-card class="bordered-card ml-4 mt-4">
                        <v-toolbar dense class="grey lighten-4 elevation-0">
                            <v-toolbar-title dense class="grey--text text-underline text--darken-4">
                                Tags
                            </v-toolbar-title>
                        </v-toolbar>
                        <v-card-text>
                            <v-select
                                v-model="resource.tags"
                                :items="[]"
                                label="Add tags to the resource"
                                multiple
                                chips
                                tags
                            ></v-select>
                        </v-card-text>
                    </v-card>

                    <v-card class="bordered-card ml-4 mt-4">
                        <v-toolbar dense class="grey lighten-4 elevation-0">
                            <v-toolbar-title dense class="grey--text text-underline text--darken-4">
                                Featured Content
                            </v-toolbar-title>
                        </v-toolbar>
                        <v-card-text>
                            <v-checkbox
                                :label="`Is this resource a featured content ?`"
                                v-model="resource.featured"
                            ></v-checkbox>
                        </v-card-text>
                    </v-card>
                  </v-flex>
              </v-layout>

          </v-card-text>

        </v-card>
        <PageFooter />
      </v-flex>
    </v-layout>
    <side-view-chat v-if="user.uid" />
  </v-container>
</template>
<script>
import { VueEditor } from "vue2-editor";
import AdminSideBarMenu from "./Components/AdminSideBar.vue";
import FileUpload from "@/components/FileUploadComponent.vue";
import SideViewChat from "@/components/chat/sideboxChat.vue";
import PageFooter from "./Components/PageFooter.vue";
export default {
  components: {
    AdminSideBarMenu,
    SideViewChat,
    PageFooter,
    FileUpload,
    VueEditor
  },
  async mounted() {
    this.mode = this.$router.currentRoute.query.mode;
    let post_id = this.$router.currentRoute.query.id;
    if (!this.mode || !post_id) {
      this.mode = "add";
    } else {
      let snapshot = await this.$firebase
        .database()
        .ref("resources")
        .child(post_id)
        .once("value");
      if (!snapshot.val()) {
        this.mode = "add";
      } else {
        this.resource = snapshot.val();
        if (this.resource.mediaType === 'video') {
          this.mediaType = this.resource.mediaType
          this.videoLink = this.resource.media.link
        } else {
          this.resourcePhotoFileURL = this.resource.media;
          this.resourcePhotoFile = this.resource.media;
        }
      }
    }
    const payload = {
      meta: {
        h1: "Add Resource",
        title: "Add Resource",
        description: "Admin Settings",
        keywords: "",
        requiresAuth: true
      }
    };
    document.title = payload.meta.title;
    this.$store.commit("setHeaderInfo", payload);
  },
  computed: {
    user() {
      return this.$store.getters.getUserDetails;
    },
    styles() {
      return this.$store.getters.getStyles;
    },
    resourceProcess() {
      return this.$store.getters.getProcess === "Resource Submit";
    }
  },
  data: () => ({
    mode: "add",
    h1: window.title,
    videoLink: "",
    mediaType: "image",
    categories: [
      "Government Contracting",
      "Defense Contracting",
      "Construction"
    ],
    contentTypes: ["News & Articles", "Training", "Workshops"],
    customToolbar: [
      [{ header: [false, 1, 2, 3, 4, 5, 6] }],

      [{ size: ["small", false, "large", "huge"] }],

      ["bold", "italic", "underline", "strike"],

      [
        { align: "" },
        { align: "center" },
        { align: "right" },
        { align: "justify" }
      ],

      [{ header: 1 }, { header: 2 }],

      ["blockquote", "code-block"],

      [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],

      [{ script: "sub" }, { script: "super" }],

      [{ indent: "-1" }, { indent: "+1" }],

      [{ color: [] }, { background: [] }],

      ["link", "formula"],

      [{ direction: "rtl" }],
      ["clean"]
    ],
    resource: {
      title: "",
      content: "",
      contenttype: "News & Articles",
      category: "Defense Contracting",
      tags: [],
      submitby: "",
      featured: false,
      media: ""
    },
    resourcePhotoUploaded: false,
    resourcePhotoFile: "",
    resourcePhotoFileName: "",
    resourcePhotoFileURL: ""
  }),
  methods: {
    validateVideoUrl(text) {
      var type = null;
      var embedUrl = null;
      text.match(
        /(http:|https:|)\/\/(player.|www.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com))\/(video\/|embed\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(\&\S+)?/
      ); // eslint-disable-line

      if (RegExp.$3.indexOf("youtu") > -1) {
        type = "youtube";
        embedUrl = `https://www.youtube.com/embed/${RegExp.$6}?autoplay=0`;
      } else if (RegExp.$3.indexOf("vimeo") > -1) {
        type = "vimeo";
        embedUrl = `https://player.vimeo.com/video/${RegExp.$6}?color=ef0000`;
      }

      if (!type) {
        return undefined;
      }
      return {
        type: type,
        link: text,
        id: RegExp.$6,
        embedUrl
      };
    },
    goBack () {
      this.$router.back()
    },
    onDismiss() {
      this.$store.dispatch("setError", null);
      this.$store.dispatch("setProcess", "null");
    },
    triggerDrawer() {
      this.drawer = !this.drawer;
    },
    addResource() {
      if (this.resource.title == "") {
        return this.showError("Please add a suitable title");
      } else if (this.resource.content == "") {
        return this.showError("Please enter some content");
      } else if (this.resource.tags.length < 1) {
        return this.showError("Please add some tags");
      } else if (this.mediaType) {
        if (
          this.mediaType === "image" &&
          !this.resourcePhotoFile &&
          !this.resourcePhotoFile.length
        ) {
          return this.showError("Please add featured media image");
        }
        if (this.mediaType === "video" && !this.videoLink.length) {
          return this.showError("Please add featured video link");
        } else if (
          this.mediaType === "video" &&
          this.videoLink.length &&
          !this.validateVideoUrl(this.videoLink).id
        ) {
          return this.showError("Please add a valid video link");
        }
      }
      let payload = {
        resource: this.resource,
        mode: this.mode,
        flags: {}
      };
      if (this.mediaType === "image") {
        payload.resource.mediaType = "image";
        payload.resource.media = this.resourcePhotoFile;
        payload.flags.photoUploaded = this.resourcePhotoFileName;
        this.cancelResourcePhoto();
      } else if (this.mediaType === "video") {
        payload.resource.mediaType = "video";
        payload.resource.media = this.validateVideoUrl(this.videoLink);
      }
      this.$store.dispatch("submitResource", payload);
    },
    showError(error) {
      let snackbar = {
        active: true,
        text: error
      };
      this.$store.dispatch("triggerSnackbar", snackbar);
      setTimeout(() => {
        let snackbar = {
          active: false,
          text: ""
        };

        this.$store.dispatch("triggerSnackbar", snackbar);
      }, 2000);
    },
    cancelResourcePhoto() {
      this.resourcePhotoUploaded = false;
      this.resourcePhotoFile = "";
      this.resourcePhotoFileName = "";
      this.resourcePhotoFileURL = "";
    },
    showResourcePhoto() {
      if (
        FileReader &&
        this.resourcePhotoFile &&
        this.resourcePhotoFile.length
      ) {
        var fr = new FileReader();
        fr.onload = function() {
          this.resourcePhotoFileURL = fr.result;
          document.getElementById("resourceActivity").src = fr.result;
        };
        fr.readAsDataURL(this.resourcePhotoFile[0]);
      } else {
      }
      this.resourcePhotoFileName = this.resourcePhotoFile[0].name;
      this.resourcePhotoUploaded = false;
    }
  }
};
</script>
<style scoped>
.datatable th.column.text-xs-left {
  text-align: center !important;
}
.my_white ul li a {
  color: white !important;
}
tr td:nth-child(2) {
  width: 21% !important;
}

.input-group--select .input-group__append-icon {
  color: #ffff61 !important;
}
.form-control {
  display: block;
  width: 100%;

  padding: 6px 12px;
  font-size: 16px;
  line-height: 1.42857143;
  color: #000;
  background-color: #fff;
  background-image: none;
  margin-bottom: 10px;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  -webkit-transition: border-color ease-in-out 0.15s,
    -webkit-box-shadow ease-in-out 0.15s;
  transition: border-color ease-in-out 0.15s,
    -webkit-box-shadow ease-in-out 0.15s;
  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s,
    -webkit-box-shadow ease-in-out 0.15s;
}
.form-control::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #000;
  opacity: 1; /* Firefox */
}

.form-control:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #000;
}

.form-control::-ms-input-placeholder {
  /* Microsoft Edge */
  color: #000;
}
.input-group--text-field label {
  position: absolute;
  top: 6px !important;
  left: 13px !important;
}
.input-group:not(.input-group--error) label {
  color: #fff !important;
}

#resourceActivity {
  border-style: dotted;
  border-width: 2px;
  height: 100px;
  padding: 15px;
  margin: 5px;
  border-color: gainsboro;
}
#close {
  float: left;
  display: inline-block;
  padding: 5px 5px;
}
</style>



// WEBPACK FOOTER //
// NewResourceView.vue?0e3c3be6